/**
 * Convert string into upper case.
 * @memberof module:stringcase/lib
 * @function uppercase
 * @param {string} str - String to convert.
 * @returns {string} Upper case string.
 */
'use strict';
/** @lends uppercase */

function uppercase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return str.toUpperCase();
}
/**
 * Checks whether the string are uppercase.
 * @memberof module:stringcase/lib
 * @function uppercase.isUppercase
 * @param {string} str - String to check
 * @returns {boolean} - True if the string are uppercase.
 */


uppercase.isUppercase = function (str) {
  return str && !/[a-z]+/.test(str);
};

module.exports = uppercase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInVwcGVyY2FzZS5qcyJdLCJuYW1lcyI6WyJ1cHBlcmNhc2UiLCJzdHIiLCJTdHJpbmciLCJ0b1VwcGVyQ2FzZSIsImlzVXBwZXJjYXNlIiwidGVzdCIsIm1vZHVsZSIsImV4cG9ydHMiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7O0FBUUE7QUFFQTs7QUFDQSxTQUFTQSxTQUFULENBQW9CQyxHQUFwQixFQUF5QjtBQUN2QkEsRUFBQUEsR0FBRyxHQUFHQyxNQUFNLENBQUNELEdBQUQsQ0FBWjs7QUFDQSxNQUFJLENBQUNBLEdBQUwsRUFBVTtBQUNSLFdBQU9BLEdBQVA7QUFDRDs7QUFDRCxTQUFPQSxHQUFHLENBQUNFLFdBQUosRUFBUDtBQUNEO0FBRUQ7Ozs7Ozs7OztBQU9BSCxTQUFTLENBQUNJLFdBQVYsR0FBd0IsVUFBVUgsR0FBVixFQUFlO0FBQ3JDLFNBQU9BLEdBQUcsSUFBSSxDQUFDLFNBQVNJLElBQVQsQ0FBY0osR0FBZCxDQUFmO0FBQ0QsQ0FGRDs7QUFJQUssTUFBTSxDQUFDQyxPQUFQLEdBQWlCUCxTQUFqQiIsInNvdXJjZVJvb3QiOiIuLi8uLi9saWIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvbnZlcnQgc3RyaW5nIGludG8gdXBwZXIgY2FzZS5cbiAqIEBtZW1iZXJvZiBtb2R1bGU6c3RyaW5nY2FzZS9saWJcbiAqIEBmdW5jdGlvbiB1cHBlcmNhc2VcbiAqIEBwYXJhbSB7c3RyaW5nfSBzdHIgLSBTdHJpbmcgdG8gY29udmVydC5cbiAqIEByZXR1cm5zIHtzdHJpbmd9IFVwcGVyIGNhc2Ugc3RyaW5nLlxuICovXG5cbid1c2Ugc3RyaWN0J1xuXG4vKiogQGxlbmRzIHVwcGVyY2FzZSAqL1xuZnVuY3Rpb24gdXBwZXJjYXNlIChzdHIpIHtcbiAgc3RyID0gU3RyaW5nKHN0cilcbiAgaWYgKCFzdHIpIHtcbiAgICByZXR1cm4gc3RyXG4gIH1cbiAgcmV0dXJuIHN0ci50b1VwcGVyQ2FzZSgpXG59XG5cbi8qKlxuICogQ2hlY2tzIHdoZXRoZXIgdGhlIHN0cmluZyBhcmUgdXBwZXJjYXNlLlxuICogQG1lbWJlcm9mIG1vZHVsZTpzdHJpbmdjYXNlL2xpYlxuICogQGZ1bmN0aW9uIHVwcGVyY2FzZS5pc1VwcGVyY2FzZVxuICogQHBhcmFtIHtzdHJpbmd9IHN0ciAtIFN0cmluZyB0byBjaGVja1xuICogQHJldHVybnMge2Jvb2xlYW59IC0gVHJ1ZSBpZiB0aGUgc3RyaW5nIGFyZSB1cHBlcmNhc2UuXG4gKi9cbnVwcGVyY2FzZS5pc1VwcGVyY2FzZSA9IGZ1bmN0aW9uIChzdHIpIHtcbiAgcmV0dXJuIHN0ciAmJiAhL1thLXpdKy8udGVzdChzdHIpXG59XG5cbm1vZHVsZS5leHBvcnRzID0gdXBwZXJjYXNlIl19